/* eslint-disable react/no-danger */
import React from "react";
import { VendorNote } from "./InternalNotesResult";
interface Props {
  vendorNotes: VendorNote[];
}
const VendorNotes = ({
  vendorNotes
}: Props) => <div data-testid="vendorNotes" data-sentry-component="VendorNotes" data-sentry-source-file="VendorNotes.tsx">
    <h4>Vendor Instructions</h4>
    {vendorNotes.map(vendorNote => vendorNote.message.length > 0 && vendorNote.type.length > 0 ? <React.Fragment key={vendorNote.type}>
          <p className="font-bold mb-0">{vendorNote.type}</p>
          <div dangerouslySetInnerHTML={{
      __html: vendorNote.message
    }} />
        </React.Fragment> : null)}
  </div>;
export default VendorNotes;